module.exports = __webpack_public_path__ + "img/home_icon.428f9fa5.svg";